import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { Token } from '../../app/app.models';

@Component({
  selector: 'page-tokenoffer',
  templateUrl: 'tokenoffer.html'
})
export class TokenofferPage {
  public token$: Token;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.token$ = navParams.data;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TokenofferPage');
  }

  cancel() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/tokenoffer/tokenoffer.ts